<template>
  <div class="upload-image-container">
    <div class="field">
      <label class="label">ID Video</label>
      <InputText
        v-model="localIdVideo"
        type="number"
        class="p-inputtext"
        placeholder="Ingrese ID del video"
        :disabled="!!idVideo"
      />
    </div>
    <div class="field">
      <label class="label">ID Pregunta</label>
      <InputText
        v-model="localIdPregunta"
        type="number"
        class="p-inputtext"
        placeholder="Ingrese ID de la pregunta"
        :disabled="!!idPregunta"
      />
    </div>
    <div class="field">
      <label class="label">Seleccionar Imagen</label>
      <input
        type="file"
        accept="image/png, image/jpeg"
        @change="handleFileChange"
        ref="fileInput"
        class="p-inputtext"
      />
    </div>
    <ButtonPrime
      label="Subir Imagen"
      icon="pi pi-upload"
      class="p-button-success"
      @click="uploadImage"
      :disabled="!file || !localIdVideo || !localIdPregunta"
    />
    <p v-if="errorMessage" class="has-text-danger">{{ errorMessage }}</p>
  </div>
</template>

<script>
import axios from 'axios';
import InputText from 'primevue/inputtext';
import ButtonPrime from 'primevue/button';

export default {
  name: 'SubirImagen',
  components: {
    InputText,
    ButtonPrime,
  },
  props: {
    idVideo: {
      type: [Number, String],
      default: null,
    },
    idPregunta: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      localIdVideo: this.idVideo,
      localIdPregunta: this.idPregunta,
      file: null,
      errorMessage: '',
    };
  },
  watch: {
    idVideo(newValue) {
      this.localIdVideo = newValue;
    },
    idPregunta(newValue) {
      this.localIdPregunta = newValue;
    },
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file && (file.type === 'image/png' || file.type === 'image/jpeg')) {
        this.file = file;
        this.errorMessage = '';
      } else {
        this.errorMessage = 'Por favor, seleccione una imagen en formato PNG o JPEG.';
        this.file = null;
      }
    },
    async uploadImage() {
      if (!this.file || !this.localIdVideo || !this.localIdPregunta) {
        this.errorMessage = 'Por favor, complete todos los campos y seleccione una imagen.';
        return;
      }

      try {
        const formData = new FormData();
        formData.append('imagen', this.file);
        console.log('FormData:', [...formData.entries()]); // Log FormData for debugging

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL_LOCAL}/Pregunta/v1/${this.localIdPregunta}/imagen`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${this.$store.getters['auth/access-token']}`,
            },
          }
        );

        this.$emit('image-uploaded', {
          idPregunta: this.localIdPregunta,
          newImageUrl: response.data.LinkImagenPregunta,
        });
        this.resetForm();
      } catch (error) {
        this.errorMessage = error.response?.data?.Message || 'Error al subir la imagen.';
        console.error('Upload error:', error.response || error);
        this.$emit('upload-error', this.errorMessage);
      }
    },
    resetForm() {
      this.file = null;
      this.errorMessage = '';
      this.$refs.fileInput.value = '';
    },
  },
};
</script>

<style scoped>
.upload-image-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.label {
  font-weight: 600;
}
.p-inputtext {
  width: 100%;
  padding: 0.5rem;
}
.has-text-danger {
  color: #dc3545;
}
.p-button-success {
  padding: 0.5rem 1rem;
}
</style> 